import { createFileRoute } from '@tanstack/react-router';

import { requireSession, requireTwoFactorEnrolment } from '@/app/guards';
import { AdminShell } from '@/app/shell';

/** Everything below requires a session and renders inside the application frame. */
export const Route = createFileRoute('/_authed')({
  beforeLoad: async ({ context, location }) => {
    const me = await requireSession({ context, location });
    requireTwoFactorEnrolment(me, location);
    return { me };
  },
  component: AdminShell,
});
